import type { CardTabsProps } from "./CardTabs.types";
import {
  CONTENT_TYPE,
  LEVEL
} from "../../consts";

/* eslint-disable max-len */

export const BlendedCourseCard: CardTabsProps = {
  learningObjectType: CONTENT_TYPE.BLENDED,
  learningObjectTypology: LEVEL.DA_EXTERNAL_RES,
  overTitle: "a cura di Serena Rossi, Giuseppe Neri, Mario Colasio ",
  percentageOfCompletion: "45%",
  shortDescription: "Il mondo del marketing sta cambiando rapidamente e la digitalizzazione rappresenta un'opportunità senza precedenti per raggiungere il tuo pubblico in modo efficace e innovativo. In questo corso, scoprirai come sfruttare al meglio le tecnologie digitali per promuovere la tua attività e raggiungere nuovi clienti.",
  title: "Marketing Digitale"
};


